import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COLOR } = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên máy CĐHA",
    name: "tenMayCDHA",
    rules: [{ required: true, message: "Chưa nhập tên máy CĐHA" }],
  },
  {
    type: INPUT,
    label: "Mã máy CĐHA",
    name: "maMayCDHA",
    rules: [{ required: true, message: "Chưa nhập mã máy CĐHA" }],
  },
];
export { dataFields };
